import { ROUTES } from '@/shared/config';
import useToken from '@/shared/lib/hooks/useToken';
import type { Role } from '@/shared/lib/types/admin';
import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';

type Props = {
  roles: Role[];
  children: ReactNode;
};

/**
 * Renders the page only for the listed roles (the role held at the pharmacy logged in to); anyone else
 * lands on the Forbidden page. A hidden menu link is not access control: before this, a known URL
 * opened the page for any role (z93r0b76qr). The backend enforces the same rules on every operation.
 */
const RequireRole = ({ roles, children }: Props) => {
  const { roleType } = useToken();
  if (!roleType || !roles.includes(roleType as Role)) return <Navigate to={ROUTES.ERROR.FORBIDDEN} replace />;
  return <>{children}</>;
};

export default RequireRole;
